import { render, staticRenderFns } from "./MultiRowsBlockListItem.vue?vue&type=template&id=f2b0ae26"
import script from "./MultiRowsBlockListItem.vue?vue&type=script&lang=ts"
export * from "./MultiRowsBlockListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports